'use strict';

wbApp.controller('CourseRegistrationCtrl', ['$scope', '$q', '$translate', '$modal', '$timeout', '$window', '$filter', 'notificationSvc', 
    'securitySvc', 'tenantSettingSvc', 'messageBoxSvc', 'classroomSvc', 'userSvc', 'urlUtils',
    'courseRegistrationSvc', 'studentSvc', 'courseSvc', 'employeeSvc', 'courseDetailSvc', 'courseScheduleSvc', 'onlinePaymentsSvc', '$analytics', 'tenantInfo',
function ($scope, $q, $translate, $modal, $timeout, $window, $filter, notificationSvc, securitySvc,
    tenantSettingSvc, messageBoxSvc, classroomSvc, userSvc, urlUtils,
    courseRegistrationSvc, studentSvc, courseSvc, employeeSvc, courseDetailSvc, courseScheduleSvc, onlinePaymentsSvc, $analytics, tenantInfo) {

    $scope.tenantSettings = tenantSettingSvc.settings;
    $scope.courseIsLoading = true;
    $scope.employeeIsLoading = true;
    $scope.studentsAreLoading = true;
    $scope.isSaving = false;
    $scope.students = null;
    $scope.userStudents = null;
    $scope.userSchedules = null;
    $scope.courseInterestsSupport = tenantSettingSvc.settings.courseInterestsSupport;
    $scope.showAskQuestionInCourseRegistration = tenantSettingSvc.settings.showAskQuestionInCourseRegistration;

    var quickRegistrationMode = tenantSettingSvc.settings.quickUserRegistrationMode;
    var previewMode = false;

    $scope.emailWasSentMessage = $translate.instant('TXT_LBL_REG_MAIL_WAS_SENT').f(tenantInfo.domain.substring(1, tenantInfo.domain.length));
    
    function validateConditionForBooking(noOfStudents) {

        if (!$scope.registrationAllowed) {
            return;
        }

        if (!securitySvc.isAuthenticated()) {
            if (!quickRegistrationMode) {
                $scope.serverError = { errors: [{ message: $translate.instant('TXT_ERROR_NOT_LOGGED_IN') }] };
            }
        } else {
            if (!noOfStudents) {
                $scope.serverError = { errors: [{ message: $translate.instant('TXT_ERROR_NO_STUDENTS') }] };
            }
        }
    }
    
    $scope.onQuickUserRegLoginClick = function() {
        let signInDialogPromise = $modal({
            templateUrl: 'sign-in/sign-in-dialog.html',
            show: false,
            scope: $scope.$new(true)
        });
        signInDialogPromise.$promise.then(function () {
            signInDialogPromise.show();
        });
    }
    
    

    function prepareQuickRegistrationReturnUrls(preview) {
        $scope.quickUserRegReturnUrl = encodeURIComponent(location.pathname + '?tabName=' + (preview 
            ? 'book-preview' 
            : $scope.courseInterestsSupport 
                ? 'book-interest' 
                : 'book-course'));
    }


    var courseID = urlUtils.getLastUrlPart();
    $scope.employee = {};

    function loadStudentRegs(refresh, registrationsLoadedCallback) {
        if ($scope.userStudents.length && (!$scope.students || refresh)) {
            $scope.students = courseRegistrationSvc.getAllForCourseAndUser(
                securitySvc.loggedInUser().userID,
                $scope.course,
                $scope.userStudents,
                false,
                tenantSettingSvc.settings.courseInterestsSupport,
                $scope.showLessonSelection);

            $scope.students.$promise.then(function () {
                $scope.studentsAreLoading = false;
                setUpScope($scope.students);
                if (!!registrationsLoadedCallback) {
                    registrationsLoadedCallback($scope.students);
                }
            });
        }
    }

    function loadPreviewData(refresh) {
        if (!$scope.userSchedules || refresh) {
            $scope.userSchedules = courseScheduleSvc.getAllForCurrentUserAndCourse($scope.course.courseID);
        }
    }

    $scope.supportsOnlinePayment = false;

    function loadData(registrationsLoadedCallback) {

        $scope.userSchedules = null;
        $scope.course = courseSvc.getByCourseID(courseID);
        $scope.course.$promise.then(function (course) {

            $scope.supportsOnlinePayment = course.supportsOnlinePayment && !$scope.courseInterestsSupport;

            $scope.showLessonSelection = !!course.allowClientLessonSelection && 
                !tenantSettingSvc.settings.courseInterestsSupport;

            var courseFreeCapacity = $scope.showLessonSelection
                ? course.maxFreePlacesForLessonSelection
                : Math.max(0, course.capacity - course.filled);

            $scope.employee = employeeSvc.getBriefByEmployeeID(course.employeeID);
            $scope.employee.$promise.then(function () {
                $scope.employeeIsLoading = false;
            });

            $scope.courseScheduleDesc = $translate.instant('TXT_COURSE_SCHEDULE_EXT').f(
                course.noOfLessons,
                !!course.firstLesson ? $filter('date')(course.firstLesson, 'short') : '',
                !!course.lastLesson ? $filter('date')(course.lastLesson, 'short') : '',
                course.lessonLengthInMinutes);

            $scope.courseScheduleWarningDesc = $translate.instant('TXT_COURSE_SCHEDULE_EXT_WARN').f(
                !!course.nearestLesson ? $filter('date')(course.nearestLesson, 'short') : '-',
                course.noOfRemainingLessons);

            $scope.showGoToScheduleHelp = !tenantSettingSvc.settings.disableClientCalendar && !!course.causalPrice;

            $scope.isCourseFull = courseFreeCapacity === 0 && !tenantSettingSvc.settings.courseInterestsSupport; // &&
                //!tenantSettingSvc.settings.coursePreviewOnlyRegistration;

            $scope.registrationAllowed = (courseFreeCapacity !== 0 ||
                (tenantSettingSvc.settings.courseInterestsSupport || tenantSettingSvc.settings.coursePreviewOnlyRegistration)) &&
                !tenantSettingSvc.settings.readOnlyClientCourseRegistration;

            $scope.images = _.map(course.pictures, function (p) {
                return {
                    thumb: p.imageUrl,
                    img: p.imageUrl
                };
            });

            if ($scope.course.amortizationScheduleMode == 2 &&
                !!$scope.course.amortizationSchedules &&
                !!$scope.course.amortizationSchedules.length) {
                var factor = ($scope.course.amortizationScheduleSurchargePct / 100) + 1;
                $scope.course.remainingPriceWithSurcharges = $scope.course.remainingPrice * factor;
            } else {
                $scope.course.remainingPriceWithSurcharges = $scope.course.remainingPrice;
            }

            if (securitySvc.isAuthenticated()) {
                studentSvc.getCurrentAsync().$promise.then(function (students) {

                    $scope.userStudents = students;

                    validateConditionForBooking(students.length);

                    if (!students.length) {
                        $scope.students = [];
                        $scope.studentsAreLoading = false;
                    } else {
                        prepareTabs();
                        if (!!$scope.students) {
                            loadStudentRegs(true, registrationsLoadedCallback);
                        }
                    }
                });
            } else{ 
                $scope.students = [];
                $scope.studentsAreLoading = false;

                validateConditionForBooking(0);
                //prepareTabs();
            }

            if ($scope.course.classroomID) {
                classroomSvc.getAsync($scope.course.classroomID).then(function (data) {
                    angular.extend($scope.classroom, data);
                });
            }

            $scope.courseIsLoading = false;
        });
    }

    loadData();
    
    $scope.classroom = { address: { location: {} } };
    $scope.loginDetails = {};
    $scope.user = {};
    $scope.loadingData = true && (!quickRegistrationMode || securitySvc.isAuthenticated());
    $scope.bookCourseTabContent = 'courses/book-course-tab-default-content.html';
    //  $scope.bookCourseTabContent = 'courses/book-course-tab-confirmation-content.html';
    $scope.allowTeacherEmailInClientSection = tenantSettingSvc.settings.allowTeacherEmailInClientSection;
    $scope.courseRegistrationEmailEnabled = tenantSettingSvc.isCourseRegistrationNotificationEnabled();
    $scope.fullCourseInterestEmailEnabled = tenantSettingSvc.isFullCourseInterestNotificationEnabled();

    $scope.invoiceSupportEnabled = tenantSettingSvc.isCourseRegistrationNotificationEnabled() && tenantSettingSvc.settings.sendInvoicesToClients;
    $scope.enableUserRegistration = tenantSettingSvc.settings.enableUserRegistration;
    $scope.shouldHidePrice = !tenantSettingSvc.settings.showPriceInCourseRegistration;
    $scope.invoiceWasSendMsg = $translate.instant('TXT_LBL_INVOICE_WAS_SEND').f(
        !tenantSettingSvc.settings.printedInvoiceName 
        ? $translate.instant('TXT_LBL_INVOICE')
        : tenantSettingSvc.settings.printedInvoiceName);

    $scope.onQuickPrevBtnClick = function () {
        $scope.tabs.activeTab -= 1;
    }


    function getReturnUrlParams() {
        var param;
        if (previewMode) {
            param = 'tabName=book-preview';
        } else {
            param = 'tabName=book-course';
        }
        return param;
    }

    function guessGender(surname) {
        if (endsWith(surname, 'ová') ||
            endsWith(surname, 'ova')) {
            return 'F';
        } else {
            return 'M';
        }

        function endsWith(str, suffix) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }
    }

    $scope.showMore = false;
    $scope.noteDescriptionInCourseRegistration = tenantSettingSvc.settings.noteDescriptionInCourseRegistration;
    $scope.showHealthInCourseRegistration = tenantSettingSvc.settings.showHealthInCourseRegistration;
    $scope.showNoteInCourseRegistration = tenantSettingSvc.settings.showNoteInCourseRegistration;
    $scope.showLessonSelection = false;
    $scope.showNearestLessonInCourses = tenantSettingSvc.settings.showNearestLessonInCourses;
    $scope.allowShareOnFBForCourses = tenantSettingSvc.settings.allowShareOnFBForCourses;
    $scope.courseRegistrationAgreement = tenantSettingSvc.settings.courseRegistrationAgreement;

    $scope.requireTermsAndConditionsAgreement = !!tenantSettingSvc.settings.requireTermsAndConditionsAgreement;
    $scope.requireTradeTermsAgreement = !!tenantSettingSvc.settings.requireTradeTermsAgreement;

    $scope.showTermsAgreement = !!$scope.courseRegistrationAgreement || $scope.requireTermsAndConditionsAgreement || $scope.requireTradeTermsAgreement;

    $scope.onPrevBtnClick = function (returnUrl) {
        if ($scope.tabs.activeTab === 0) {
            window.location = returnUrl;
        } else {
            $scope.tabs.activeTab = 0;
        }
    }

    $scope.onBookPreviewBtnClick = function () {
        previewMode = true;

        if (!securitySvc.isAuthenticated()) {
            if (quickRegistrationMode) {
                courseDetailSvc.addQuickUserRegistrationTabIfNeeded($scope.tabs);
                courseDetailSvc.switchToQuickUserRegistrationTab($scope.tabs);
                prepareQuickRegistrationReturnUrls(true);
            } else {
                notificationSvc.advertiseLogin(getReturnUrlParams());
            }
            return;
        }

        courseDetailSvc.switchToBookPreviewTab($scope.tabs);
    }

    $scope.onBtnNextClick = function () {
        $scope.tabs.activeTab += 1;
    }

    $scope.setSelectedSchedule = function (selectedSchedule) {
        $scope.selectedSchedule = selectedSchedule;
    }

    $scope.confirmPreview = { title: "" };

    var confirmPreviewDlg = $modal({
        templateUrl: '/partials/confirm-preview.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    $scope.onPreviewButtonClick = function (schedule, attendance, courseID) {
        $scope.confirmPreview.title = getAttendanceOperationTitle(attendance);
        $scope.confirmPreview.description = getAttendanceOperationDescription(attendance, schedule);
        $scope.confirmPreview.attendance = attendance;
        $scope.confirmPreview.schedule = schedule;
        $scope.confirmPreview.courseID = courseID;

        confirmPreviewDlg.$promise.then(function () {
            confirmPreviewDlg.show();
        });
    }

    var confirmRegistrationDlg = $modal({
        templateUrl: '/partials/confirm-registration.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    $scope.confirmRegistration = {
        students: []
    };

    // TODO: courseDetailSvc
    $scope.onBookCourseBtnClick = function () {
        $scope.course.$promise.then(function (course) {
            if ($scope.students && $scope.students.$promise) {
                $scope.students.$promise.then(function () {
                    $scope.confirmRegistration.courseRegistrationAgreementAccepted = !$scope.courseRegistrationAgreement;
                    $scope.confirmRegistration.requireTermsAndConditionsAgreementAccepted = !$scope.requireTermsAndConditionsAgreement;
                    $scope.confirmRegistration.requireTradeTermsAgreementAccepted = !$scope.requireTradeTermsAgreement;

                    $scope.confirmRegistration.students = _.filter($scope.students, { isNew: true, attend: true });
                    $scope.confirmRegistration.courseID = $scope.course.courseID;
                    $scope.confirmRegistration.description = courseDetailSvc.getConfirmRegistrationDescription(
                        $scope.students,
                        $scope.origStudents,
                        $scope.course);

                    confirmRegistrationDlg.$promise.then(function () {
                        confirmRegistrationDlg.show();

                        $analytics.eventTrack('CourseRegistrationConfirm');
                    });
                });
            }
        });
    }

    $scope.onRegisterClick = function (returnUrl) {
        previewMode = false;

        if (!securitySvc.isAuthenticated()) {
            if (quickRegistrationMode) {
                courseDetailSvc.addQuickUserRegistrationTabIfNeeded($scope.tabs);
                courseDetailSvc.switchToQuickUserRegistrationTab($scope.tabs);
                prepareQuickRegistrationReturnUrls(false);
            } else {
                notificationSvc.advertiseLogin(getReturnUrlParams());
            }
            return;
        }

        if (!$scope.tabs.activeTab) {
            if (tenantSettingSvc.settings.courseInterestsSupport) {
                $scope.tabs.activeTab += 1;
            } else {
                courseDetailSvc.switchToCourseRegistrationTab($scope.tabs);
            }
        }
    }

    $scope.onAttendanceChangeClick = function (attendance, schedule, courseID) {
        function success(schedules, selected) {
            $scope.userSchedules = schedules;

            $scope.setSelectedSchedule(selected);
        }

        courseDetailSvc.savePreviewAttendanceChange(
            attendance.studentID,
            schedule.courseScheduleID,
            courseID,
            success);
    }

    $scope.onBookFullCourseInterestClick = function () {
        var students = _.filter($scope.students, { isNew: true, attend: true });
        var course = $scope.course;
        var classroom = $scope.classroom;

        courseRegistrationSvc.createFullCourseInterest(students, course, classroom).then(function () {
            $scope.bookCourseTabContent = 'courses/book-full-course-interest-tab-confirmation-content.html';
        }, function (error) {
        });
    }
    
    $scope.onRegistrationConfirmClick = function (courseID, students, hideFn) {

        if (!$scope.confirmRegistration.courseRegistrationAgreementAccepted ||
            !$scope.confirmRegistration.requireTermsAndConditionsAgreementAccepted ||
            !$scope.confirmRegistration.requireTradeTermsAgreementAccepted) {

            var m = {
                title: 'TXT_TITLE_INFORMATION',
                message: 'TXT_AGREE_TO_TERMS_AND_CONDITIONS',
                buttons: [{
                    text: 'TXT_BTN_OK'
                }]
            };

            messageBoxSvc.showMessageDlg(m);

        } else {
            $scope.isSaving = true;

            var notificationConfig = {
                sendEmailNotification: true,
                sendSmsNotification: false 
            };

            // Clear all errors
            _.forEach(students, function (student) {
                student.markErrorAttendance.call(student, []);
            });

            courseRegistrationSvc.insertAll(students, courseID, notificationConfig, 1, function () {
                $scope.bookCourseTabContent = 'courses/book-course-tab-confirmation-content.html';
                hideFn();
                $analytics.eventTrack('CourseRegistrationAccepted');
                loadData(function (registrations) {

                    if ($scope.supportsOnlinePayment) {

                        var newRegistrations = _.intersectionBy(registrations, students, 'studentID');
                        var invoiceIDs = _.map(newRegistrations, 'invoiceID');
                        var price = _.sumBy(newRegistrations, 'arrearByAmortizationSchedule');

                        // TODO: arrearByAmortizationSchedule should offer here the first payment regardless of schedule

                        if (price > 0) {
                            messageBoxSvc.showMessageDlg({
                                title: 'TXT_TITLE_CONFIRM_ONLINE_PAYMENT',
                                message: '<i class="fa fa-3x fa-credit-card text-success pull-right" aria-hidden="true"></i>' +
                                    $translate.instant('TXT_CONFIRM_CONFIRM_START_ONLINE_PAYMENT'),
                                buttons: [{
                                    text: 'TXT_BTN_NO'
                                }, {
                                    text: 'TXT_BTN_YES',
                                    callback: function () { return onlinePaymentsSvc.startOnlinePayment(invoiceIDs, price).$promise; }
                                }]
                            });
                        }
                    }
                });

                $scope.isSaving = false;
            }, function (errorResult) {               
                $scope.isSaving = false;

                // If error is CourseFullException 
                if ($scope.showLessonSelection) {

                    if (errorResult && errorResult.errors && errorResult.errors.length === 1 &&
                        errorResult.errors[0].code === 5) {

                        var scheduleIDs = _.transform(errorResult.errors[0].data.courseScheduleIDs.split(","),
                            function (result, n) {
                                result.push(parseInt(n));
                            }, []);

                        _.forEach(students, function (student) {
                            student.markErrorAttendance.call(student, scheduleIDs);
                        });

                        courseRegistrationSvc.refreshSchedules(students, courseID).then(function () {
                            hideFn();
                        });
                    }
                }
            });
        }
    }

    $scope.onConfirmRegistrationPrevBtnClick = function () {
        $scope.bookCourseTabContent = 'courses/book-course-tab-default-content.html';
    }

    $scope.onConfirmFullCourseInterestPrevBtnClick = function () {
        $scope.bookCourseTabContent = 'courses/book-course-tab-default-content.html';
        $scope.tabs.activeTab = 0;
        urlUtils.setUrlParam("tabName", $scope.tabs[$scope.tabs.activeTab].name);
    }

    $scope.onConfirmRegistrationBackToCourseListBtnClick = function () {
        $window.location.href = $window.location.origin + '/Courses'
    }

    function getAttendanceOperationTitle(attendance) {
        if (attendance.canRegisterForPreview) {
            return $translate.instant("TXT_REGISTER_FOR_PREVIEW_ACTION");
        } else {
            return $translate.instant("TXT_EXCUSE_ACTION");
        }
    }

    function getAttendanceOperationDescription(attendance, schedule) {
        if (attendance.canRegisterForPreview) {
            return $translate.instant("TXT_REGISTER_FOR_PREVIEW_ACTION_DESC")
                .f(attendance.fullName, schedule.scheduleDate + " " + schedule.scheduleTime);
        } else {
            return $translate.instant("TXT_EXCUSE_ACTION_DESC_BRIEF")
                .f(attendance.fullName, schedule.scheduleDate + " " + schedule.scheduleTime);
        }
    }

    $scope.tabs = [
        {
            title: 'TXT_TAB_COURSE_DETAIL',
            template: 'courses/course-detail-tab.html',
            name: 'detail',
            disable: false
        }];

    $scope.showOnlinePaymentResult = false;
    $scope.onlinePaymentResultMessage = null;
    $scope.onlinePaymentStatusColor = 'inherit';
    $scope.showRetryOnlinePayment = false;

    function showOnlinePaymentResultsIfNeeded() {
        var onlinePaymentIDStr = urlUtils.getQueryParams()['onlinePaymentID'];
        if (!!onlinePaymentIDStr) {
            var onlinePaymentID = Number(onlinePaymentIDStr);

            $scope.showOnlinePaymentResult = $scope.supportsOnlinePayment;
            $scope.bookCourseTabContent = 'courses/book-course-tab-confirmation-content.html';

            onlinePaymentsSvc.getTransactionState(onlinePaymentID).$promise.then(
                function (data) {
                    $scope.onlinePaymentResultMessage = onlinePaymentsSvc.getOnlinePaymentResultMessage(data);
                    switch (data.state) {
                        case 2: // Pending
                            $scope.onlinePaymentStatusColor = 'orange';
                            break;
                        case 3: // Paid
                            $scope.onlinePaymentStatusColor = 'green';
                            break;
                        default:
                            $scope.onlinePaymentStatusColor = 'red';
                            $scope.showRetryOnlinePayment = true;
                            break;
                    }
                    $scope.onlinePaymentStatus = data.state;
                    urlUtils.removeUrlParam('onlinePaymentID');
                }
            );
        } else {
            $scope.showOnlinePaymentResult = false;
        }
    }

    function switchToCorrectTab() {
        var tabName = urlUtils.getQueryParams()['tabName'];
        if (!!tabName) {
            // find correct tab
            var tabIndexToActivate = _.findIndex($scope.tabs, { name: tabName });
            if (tabIndexToActivate !== -1) {
                if ($scope.tabs.activeTab !== tabIndexToActivate) {
                    $scope.tabs.activeTab = tabIndexToActivate;
                }
                showOnlinePaymentResultsIfNeeded();
                return;
            }

        }

        $scope.tabs.activeTab = 0;
        urlUtils.setUrlParam("tabName", $scope.tabs[$scope.tabs.activeTab].name);
        showOnlinePaymentResultsIfNeeded();
    }

    var preparedTabsCalled = false;

    function prepareTabs() {
        if (!quickRegistrationMode || securitySvc.isAuthenticated()) {
            if (!$scope.serverError && ($scope.registrationAllowed || ($scope.isCourseFull && tenantSettingSvc.settings.enableFullCourseInterest))) {

                if (($scope.isCourseFull && tenantSettingSvc.settings.enableFullCourseInterest) || !$scope.isCourseFull) {
                    courseDetailSvc.addBookCourseTabIfNeeded($scope.tabs);
                }
                courseDetailSvc.addBookInterestTabIfNeeded($scope.tabs);
                courseDetailSvc.addBookPreviewTabIfNeeded($scope.tabs);

                switchToCorrectTab();
            }
        }

        preparedTabsCalled = true;
    }

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {

        if (preparedTabsCalled || !urlUtils.getQueryParams()['tabName']) {
            var tabName = $scope.tabs[newValue].name;
            urlUtils.setUrlParam("tabName", tabName);
        }

        if (courseDetailSvc.isOnBookCourseTab($scope.tabs, newValue) ||
            courseDetailSvc.isOnBookInterestTab($scope.tabs, newValue)) {
            loadStudentRegs(false);
        } else if (courseDetailSvc.isOnBookPreviewTab($scope.tabs, newValue))
        {
            loadPreviewData(false);
        }
    });

    $scope.shouldShowPreviewButton = function () {
        if (!tenantSettingSvc.settings.coursePreviewOnlyRegistration) {
            return false;
        }

        if (!!$scope.serverError) {
            if (securitySvc.isAuthenticated()) {
                return false;
            }
        }

        if ($scope.tabs.length > 2) {
            return $scope.tabs.activeTab != 2;
        }

        return ($scope.tabs.activeTab == 0) && $scope.registrationAllowed;
    }

    $scope.shouldShowRegisterButton = function () {
        if (!tenantSettingSvc.settings.allowClientCourseRegistration && 
            !tenantSettingSvc.settings.courseInterestsSupport) {
            return false;
        }

        if (!!$scope.serverError) {
            if (securitySvc.isAuthenticated()) {
                return false;
            }
        }

        if ($scope.isCourseFull) {
            return false;
        }

        if ($scope.tabs.length > 2) {
            return $scope.tabs.activeTab != 2;
        }

        return $scope.registrationAllowed;
    }

    $scope.shouldShowFullCourseInterestButton = function () {
        if (!tenantSettingSvc.settings.allowClientCourseRegistration &&
            !tenantSettingSvc.settings.courseInterestsSupport) {
            return false;
        }

        if (tenantSettingSvc.settings.readOnlyClientCourseRegistration || 
            !tenantSettingSvc.settings.enableFullCourseInterest) {
            return false;
        }

        if (!$scope.isCourseFull) {
            return false;
        }

        if (!!$scope.serverError) {
            if (securitySvc.isAuthenticated()) {
                return false;
            }
        }

        if ($scope.tabs.length > 2) {
            return $scope.tabs.activeTab != 2;
        }



        return true;
    }


    $scope.shouldEnableRegisterButton = function() {
        if (!$scope.tabs.activeTab)
            return true;

        if (courseDetailSvc.isOnBookCourseTab($scope.tabs, $scope.tabs.activeTab) || 
            courseDetailSvc.isOnBookInterestTab($scope.tabs, $scope.tabs.activeTab)) {
            if ($scope.students && !$scope.studentsAreLoading) {
                return !angular.equals($scope.origStudents, $scope.students) &&
                    !!_.find($scope.students, { attend: true, isNew: true });
            }
        }

        return false;
    }

    $scope.onAttendClick = function (student) {
        if (tenantSettingSvc.settings.courseInterestsSupport &&
            !student.attend && student.isEditable) {
            student.selfAssessedProficiencyLevelID = null;
            student.notes = null;
            student.health = null;
        }
    }

    function setUpScope(students) {
       
        $scope.origStudents = angular.copy(students);

        // Preselect student if only one is defined
        if (!!students && students.length == 1) {
            var student = students[0];
            if (student.isNew) {
                student.attend = true;
            }
        }
    }

    var userQuestionDlg = $modal({
        templateUrl: '/partials/user-question.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    var amortizationScheduleDlg = $modal({
        templateUrl: '/partials/book-course-amortization-schedule.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    $scope.showAmortizationSchedule = function(studentRegistration) {
        amortizationScheduleDlg.$promise.then(function () {
            amortizationScheduleDlg.$scope.model = studentRegistration;
            amortizationScheduleDlg.$scope.amortizationScheduleTemplates = $scope.course.amortizationSchedules;
            amortizationScheduleDlg.show();
        });
    }

    $scope.onUserQuestionAsk = function () {
        $scope.course.$promise.then(function (course) {
            userQuestionDlg.$promise.then(function () {
                userQuestionDlg.$scope.isAuthenticated = securitySvc.isAuthenticated();
                userQuestionDlg.$scope.userQuestion = { courseID: $scope.course.courseID, emailAddress: null, question: null };
                userQuestionDlg.show();
            });
        });
    }


    // TODO: courseDetailSvc
    $scope.onUserQuestionSend = function (userQuestion) {

        courseDetailSvc.askQuestionAboutCourse(
            userQuestion.courseID,
            userQuestion.emailAddress,
            userQuestion.question);
    }

}]);